"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("./Card"));

require("./CardDeck.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CardDeck = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var trumpCard = _ref.trumpCard,
      hidden = _ref.hidden;

  if (hidden) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "card-deck"
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-deck"
  }, trumpCard && /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    trump: true,
    suit: trumpCard.suit,
    label: trumpCard.label
  }), /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    deck: true,
    side: "back"
  }));
}, function (nextProps, prevProps) {
  return nextProps.trumpCard === prevProps.trumpCard && nextProps.hidden === prevProps.hidden;
});
CardDeck.displayName = 'CardDeck';
CardDeck.propTypes = {
  trumpCard: _propTypes["default"].object,
  hidden: _propTypes["default"].bool
};
var _default = CardDeck;
exports["default"] = _default;